import { Button, Box } from '@mui/material';

export default function MissionActions({ data }) {
    const JSONToFile = (obj, filename) => {
        const blob = new Blob([JSON.stringify(obj, null, 2)], {
            type: 'application/json',
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}.json`;
        a.click();
        URL.revokeObjectURL(url);
    };

    const exportJSON = () => {
        if (!data) return;
        JSONToFile(JSON.stringify(data), 'missionJsonFile');
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box>
                <Button variant="outlined" size="small" onClick={exportJSON}>
                    Export JSON
                </Button>
            </Box>
        </Box>
    );
}
